export const INTERAC_PAYMENT = 'interacPayment';
export const EFT_PAYMENT = 'eftPayment'; // Direct deposit
export const STRIPE_PAYMENT = 'stripePayment';
export const PAYMENT_TYPES = [INTERAC_PAYMENT, EFT_PAYMENT, STRIPE_PAYMENT];
